<template>
  <div class="c-nav c-nav--floating-footer-sticky">
    <button
      class="c-button c-button--primary c-button--width-fuid c-button--mobile-small waves-effect"
      @click.prevent="callValidateStep4"
    >
      Continuar
    </button>
  </div>
</template>

<script>
export default {
  name: "Step4-Footer",
  methods: {
    callValidateStep4() {
      this.$eventBus.$emit("validateCompraTraeStep4");
    },
  },
};
</script>
